import de from './locale/de.json';
import en from './locale/en.json';
import es from './locale/es.json';
import fr from './locale/fr.json';
import it from './locale/it.json';
import pt from './locale/pt.json';
import pt_BR from './locale/pt_BR.json';

export default {
  de,
  en,
  es,
  fr,
  it,
  pt,
  pt_BR,
};
